<!-- 日历组件 -->
<template>
   <calendarComponent
      :class="{calendars: componentConfig.calendarType == '1', calendarmapp: !isH5, calendarmh5: isH5 }"
      v-if="show"
      :platform="platform"
      :sensors="sensors"
      :componentConfig="componentConfig"
   >
   </calendarComponent>
</template>
<script>
import { mapState } from "vuex";
import calendarComponent from '@51job/jbs-bigcard-component/lib/Calendar.js';
export default {
   name:'Calendar',
   components:{
      calendarComponent
   },
   props:{
      componentConfig:{
         type:Object,
         default:()=>{
            return  {}
         }
      }
   },
   computed:{
      ...mapState(["commonStore"]),
      platform() {
         return this.commonStore.platform;
      },
      isForPC(){
         return this.commonStore.isForPC
      },
      show(){
         let temp = false
         if(this.componentConfig.calendarType == '1'){//单日程 仅在app内显示
            if(this.commonStore.platform === 'yjsApp' || this.commonStore.platform === '51jobApp' || this.commonStore.platform === 'ehireApp'){
               temp = true
            }else{
               temp = false
            }
         }else{//多日程
            temp = !this.$store.state.commonStore.isForPC
         }
         return temp
      },
      isH5() {
         return this.componentConfig.calendarType == '2' && this.platform != '51jobApp' && this.platform != 'yjsApp' && !this.isForPC
      }
   },
   data() {
      return {
         sensors: {//埋点实例
            track: this.$sensors.track,
            quick: this.$sensors.quick
         }
      }
   }
}
</script>
<style lang="less" scoped>
.calendars {
   position: relative;
   margin-bottom: 16px;
}

.calendarmapp {
   /deep/.calendar-new .buoy {
      top: 104px;
   }
}

.calendarmh5 {
   /deep/.calendar-new .buoy {
      top: 60px;
   }
}
</style>
